module.exports = __webpack_public_path__ + "img/Trupp_MHP.d471628c.svg";